import { filterTypes } from '../settings/types'

const initialState = {
    page: 1,
    sizePerPage: 10,
    currentIndex: 0,
    totalSize:10,
    loadData: true,
    listItems:null,
    filterInfo:null
}

const filterReducer = (state = initialState, action) => {
    switch (action.type) {
        case filterTypes.items:
            return {
                ...state,
                listItems: action.payload,
            }
        case filterTypes.filter:
            return {
                ...state,
                loadData: true,
                filterInfo: action.payload
            }
        case filterTypes.tableInfo:
            return {
                ...state,
                loadData: true,
                page: action.payload?.page,
                sizePerPage: action.payload?.sizePerPage,
                currentIndex: action.payload?.currentIndex,
                totalSize: action.payload?.totalSize,
            }
        case filterTypes.loadData:
            return {
                ...state,
                loadData: action.payload
            }
        case filterTypes.removeItem: {
            const newList = state.listItems.filter( item => item.id != action.payload)
            return { ...state, listItems: newList}
        }
        case filterTypes.addItem: {
            const newList = state.listItems.slice()
            newList.unshift(action.payload)
            return { ...state, listItems: newList}
        }
        case filterTypes.clear:
            return initialState
        case filterTypes.changeItem:{
            const items = state.listItems.slice()
            const index = items.findIndex(i => i.id === action.payload.id);
            items[index] = action.payload
            return { ...state, listItems: items}
        }
        default:
            return state
    }
}

export default filterReducer